<div class="login-wrapper">
  <div class="login-content">
    <h2 class="title">Reset Password</h2>
    <p class="subtitle">Enter the new password to activate your account.</p>
    <form [formGroup]="passwordForm" class="login-form" (submit)="activateAccount()">
      <div
        class="field-type-1"
        [ngClass]="{ invalid: passwordForm.controls['password'].dirty && passwordForm.controls['password'].errors }">
        <label for="" class="field-label">Password <span class="field-mandatory">*</span></label>
        <input [type]="hidePassword ? 'password' : 'text'" class="field-input" formControlName="password" />
        <img
          [src]="hidePassword ? 'assets/images/view.svg' : 'assets/images/hide.svg'"
          alt="hide"
          class="show-password"
          tabindex="0"
          role="button"
          (click)="showPasswordToggle()"
          (keydown.enter)="showPasswordToggle()"
          (keydown.space)="showPasswordToggle()" />
      </div>
      @if (passwordForm.controls['password'].dirty && passwordForm.controls['password'].errors) {
      <p [ngClass]="{ 'success-message': passwordMinLengthCheck() }" class="error-message">
        <img
          [src]="
            passwordMinLengthCheck() ? 'assets/images/circle-checked-fill.svg' : 'assets/images/close-circle-fill.svg'
          "
          alt="hide"
          class="valid-icons" />
        <span class="msg">Password must be at least 8 characters long.</span>
      </p>
      <p [ngClass]="{ 'success-message': !checkPasswordError('uppercase') }" class="error-message">
        <img
          [src]="
            !checkPasswordError('uppercase')
              ? 'assets/images/circle-checked-fill.svg'
              : 'assets/images/close-circle-fill.svg'
          "
          alt="hide"
          class="valid-icons" />
        <span class="msg">Password must contain an uppercase letter.</span>
      </p>
      <p [ngClass]="{ 'success-message': !checkPasswordError('lowercase') }" class="error-message">
        <img
          [src]="
            !checkPasswordError('lowercase')
              ? 'assets/images/circle-checked-fill.svg'
              : 'assets/images/close-circle-fill.svg'
          "
          alt="hide"
          class="valid-icons" />
        <span class="msg">Password must contain a lowercase letter.</span>
      </p>
      <p [ngClass]="{ 'success-message': !checkPasswordError('number') }" class="error-message">
        <img
          [src]="
            !checkPasswordError('number')
              ? 'assets/images/circle-checked-fill.svg'
              : 'assets/images/close-circle-fill.svg'
          "
          alt="hide"
          class="valid-icons" />
        <span class="msg">Password must contain a number.</span>
      </p>
      <p [ngClass]="{ 'success-message': !checkPasswordError('specialCharacter') }" class="error-message">
        <img
          [src]="
            !checkPasswordError('specialCharacter')
              ? 'assets/images/circle-checked-fill.svg'
              : 'assets/images/close-circle-fill.svg'
          "
          alt="hide"
          class="valid-icons" />
        <span class="msg">Password must contain a special character.</span>
      </p>
      @if (passwordMaxLengthCheck()) {
      <p class="error-message">
        <img
          [src]="
            passwordMaxLengthCheck() ? 'assets/images/close-circle-fill.svg' : 'assets/images/circle-checked-fill.svg'
          "
          alt="hide"
          class="valid-icons" />
        <span class="msg">Password range must be less than 25.</span>
      </p>
      } }

      <div
        class="field-type-1"
        [ngClass]="{
          invalid: passwordForm.controls['confirm_password'].dirty && passwordForm.controls['confirm_password'].errors
        }">
        <label for="" class="field-label">Confirm Password <span class="field-mandatory">*</span></label>
        <input
          [type]="hideConfirmPassword ? 'password' : 'text'"
          class="field-input"
          formControlName="confirm_password" />
        <img
          [src]="hideConfirmPassword ? 'assets/images/view.svg' : 'assets/images/hide.svg'"
          alt="hide"
          class="show-password"
          tabindex="0"
          role="button"
          (click)="showConfirmPasswordToggle()"
          (keydown.enter)="showConfirmPasswordToggle()"
          (keydown.space)="showConfirmPasswordToggle()" />
      </div>
      @if (passwordForm.controls['confirm_password'].dirty && passwordForm.controls['password'].dirty &&
      passwordForm.value['password'] !== passwordForm.value['confirm_password']) {
      <p class="error-message">
        <img src="assets/images/close-circle-fill.svg" alt="error" class="valid-icons" />
        <span class="msg">Passwords don't match.</span>
      </p>
      }
      <button class="login-btn" type="submit" [disabled]="!passwordForm.valid || loading()">Reset Password</button>
    </form>
  </div>
</div>
